const getLocation = (rootState) => rootState.ui.controlPane.location;

export default getLocation;
